const NOTIFICATION_AUDIO_KEY = "eternua.notificationAudioEnabled";

export function isNotificationAudioEnabled() {
  if (typeof window === "undefined") return true;
  const stored = window.localStorage.getItem(NOTIFICATION_AUDIO_KEY);
  if (stored === null) return true;
  return stored !== "false";
}

export function setNotificationAudioEnabled(value) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(NOTIFICATION_AUDIO_KEY, value ? "true" : "false");
  } catch (_) {
    // no-op
  }
}

export function playNotificationSound(src, options = {}) {
  if (!isNotificationAudioEnabled() || typeof window === "undefined") return null;
  const sound = new Audio(src);
  if (typeof options.volume === "number") sound.volume = options.volume;
  if (options.loop) sound.loop = true;
  sound.play().catch(() => {});
  return sound;
}

export function stopNotificationSoundByRef(sound) {
  if (sound && typeof sound.pause === "function") {
    sound.pause();
    sound.currentTime = 0;
  }
}
